<template>
  <CodeVerification
    :description="t(useTranslationPath(callerPath, 'description'))"
    :site-id="authStore.maintainableEntity.id"
    :is-loading
    @valid="handleCheckIn"
  />
</template>

<script setup>
import CodeVerification from '@/components/Verification/CodeVerification.vue'
import { useTranslationPath } from '@/composables/useTranslationPath.js'
import { isAccessCodeEnabled } from '@/composables/useVerificationMethod.js'
import { useAppStore } from '@/stores/AppStore.js'
import { useAuthStore } from '@/stores/authenticated/AuthStore'
import { useEngineerStore } from '@/stores/authenticated/EngineerStore.js'
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

const { t } = useI18n()

const router = useRouter()

const appStore = useAppStore()
const authStore = useAuthStore()
const engineerStore = useEngineerStore()

const callerPath = 'views.authenticated.verification.code'

const isLoading = ref(false)

onMounted(async () => {
  appStore.$patch({ showBackButton: false })
  engineerStore.$patch({
    verificationData: {
      checkIn: { method: null, data: null },
      checkOut: { method: null, data: null },
    },
  })

  if (!isAccessCodeEnabled('ENGINEER_APP_CHECK_IN_METHOD')) {
    await router.push({ name: 'work-order.index' })
  }
})

const handleCheckIn = async (verified = true) => {
  isLoading.value = true

  if (verified) {
    engineerStore.$patch({
      verificationData: {
        checkIn: {
          method: 'ACCESS_CODE',
          data: null,
        },
        checkOut: {
          method: null,
          data: null,
        },
      },
    })

    await router.push({ name: 'work-order.index' })
  }

  isLoading.value = false
}
</script>
